module.exports = __webpack_public_path__ + "static/Onomy-8bf7d3018bac85a0a091a5ac3a5c48f2.png";